import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { resourceCache, useAsyncResource } from "use-async-resource";
import { ProjectDto } from "../../api/APIClient";
import { fetchProjects } from "../../api/Fetchers";
import { ProjectContext } from "../../Context/ProjectContext";
import CategoryHeader from "../Common/Components/CategoryHeader";
import ErrorBoundary from "../Common/Components/ErrorBoundary";
import Loading from "../Common/Components/Loading";
import { usePanelProjectContext } from "../PanelProjectProvider";
import ProjectsList from "./Components/ProjectsList";

const useStyles = makeStyles({
    root: {
        marginTop: 30,
    },
});

const Projects = (): JSX.Element => {
    const classes = useStyles({ isMobile: false });
    const { t } = useTranslation("main");
    const [projectsReader, getProjects] = useAsyncResource(fetchProjects, []);
    const reloadProjects = React.useCallback(() => {
        resourceCache(fetchProjects).clear();
        getProjects();
    }, []);

    const { setProject } = usePanelProjectContext();
    const project = React.useContext<ProjectDto>(ProjectContext);
    // React.useEffect(() => {
    //     setProject(project);
    // }, []);

    return (
        <Container maxWidth="lg" className={classes.root}>
            <CategoryHeader title={t("projects.projects")} />
            <ErrorBoundary errorMessage={t("projects.projectsError")}>
                <Suspense fallback={<Loading />}>
                    <ProjectsList projectsReader={projectsReader} />
                </Suspense>
            </ErrorBoundary>
        </Container>
    );
};

export default Projects;
